/* global G */
import { pipe } from '@gaia/util'
import { moduleComposition } from '@gaia/trait/composition'
import { withGetterSetter, withObjectFreeze } from '@gaia/trait/with'
import { usesGetterSetter } from '@gaia/trait/uses'
import usesWindowHash from '@platform/trait/uses/WindowHash'
import EventAdapter from '@platform/adapter/event'

/** @type {Gaia.Web.Application} */
export default pipe(
  moduleComposition('platform.web'),
  withGetterSetter(G.REF),
  withGetterSetter(G.SESSION),
  withGetterSetter(G.PROVIDER),
  withGetterSetter(G.ADAPTER),
  withGetterSetter(G.EVENTS),
  usesGetterSetter(G.EVENTS, EventAdapter()),
  usesWindowHash,
  withObjectFreeze,
)
